import { FC, PropsWithChildren, createContext, useContext } from 'react';

import { User } from '@/features/auth/types';

export interface AppAuthContextValue {
  user: User;
  logout: () => void;
}

const AppAuthContext = createContext<AppAuthContextValue | null>(null);

export const AppAuthProvider: FC<PropsWithChildren<{ value: AppAuthContextValue }>> = ({
  value,
  children,
}) => <AppAuthContext.Provider value={value}>{children}</AppAuthContext.Provider>;

export const useAppAuth = (): AppAuthContextValue => {
  const context = useContext(AppAuthContext);
  if (!context) {
    throw new Error('useAppAuth must be used within AppAuthProvider');
  }

  return context;
};
